module.exports = __webpack_public_path__ + "img/jxm.f4e7b3f9.jpg";